export const normalizeAppBase = (base = '') => {
	const normalized = `${base ?? ''}`.trim();
	if (!normalized || normalized === '/') {
		return '';
	}
	return normalized.startsWith('/')
		? normalized.replace(/\/+$/, '')
		: `/${normalized.replace(/\/+$/, '')}`;
};

export const isExternalPath = (path: string) =>
	/^[a-z][a-z0-9+.-]*:/i.test(path) || path.startsWith('//');

export const appPath = (path = '/', base = '') => {
	const value = `${path ?? ''}`;
	if (!value || value.startsWith('#') || isExternalPath(value)) {
		return value;
	}

	const appBase = normalizeAppBase(base);
	if (!appBase) {
		return value.startsWith('/') ? value : `/${value}`;
	}

	if (value === appBase || value.startsWith(`${appBase}/`)) {
		return value;
	}

	if (value === '/') {
		return `${appBase}/`;
	}

	return `${appBase}${value.startsWith('/') ? value : `/${value}`}`;
};

export const stripAppBase = (pathname = '/', base = '') => {
	const value = pathname.startsWith('/') ? pathname : `/${pathname}`;
	const appBase = normalizeAppBase(base);
	if (!appBase) {
		return value;
	}

	if (value === appBase) {
		return '/';
	}
	if (value.startsWith(`${appBase}/`)) {
		return value.slice(appBase.length) || '/';
	}

	return value;
};
